import auth from './auth';
import prescription from './prescription';

export default {
  auth,
  prescription,
}
